module.exports = __webpack_public_path__ + "static/media/lorry_14ft.0b27e1e9.svg";